
import { defineComponent, SetupContext, PropType } from 'vue';
import { IElRow, IElCol } from '@/types/index.d';
import { cloneDeep } from 'lodash-es';

interface RowConfig {
  props?: IElRow;
  [key: string]: any;
}

interface ColConfig {
  props?: IElCol | null;
  [key: string]: any;
}

export default defineComponent({
  name: 'ResponsiveRow',
  props: {
    row: {
      type: Object as PropType<RowConfig>,
    },
    col: {
      type: Object as PropType<ColConfig>,
    },
  },
  setup(props, { slots }: SetupContext) {
    return () => {
      const { col = {}, row } = props;
      const childList = (slots.default && slots.default()) || [];

      // 默认参数
      const defaultColProps = { xs: 24, sm: 12, md: 8, lg: 8, xl: 6 } as IElCol;

      type TChild = typeof childList;

      const colChildList = [] as TChild;
      const getColChild = (_childList: TChild) => {
        if (Array.isArray(_childList)) {
        _childList?.forEach((child) => {
          // 优先级：默认 < 父组件col < 子组件col
          const childCol = cloneDeep(Object.assign(defaultColProps, col, child.props?.col || {}));
          const _type = child?.type as any;
          if (_type?.name === 'ElCol') {
            colChildList.push(child);
            return;
          }
          if (!_type?.name) {
            if (Object(_type).toString() === 'Symbol(Comment)') {
              return;
            }
          }
          if (child?.children?.length) {
            getColChild(child.children as TChild);
            return;
          }
          colChildList.push(
            (<el-col { ...childCol }>
              { child }
            </el-col>),
          );
        });
        }
      };
      getColChild(childList);
      return (
        <el-row { ...(row || {}) }>
          {
            colChildList
          }
        </el-row>
      );
    };
  },
});
